import "./VerifyAccountDetail.css";

import { storeUser } from "../../../../redux/users/usersSlice";
import { toastify } from "../../../../helpers/toast/toastify";
import { useDispatch, useSelector } from "react-redux";
import editIcon from "../../../../assets/images/edit.svg";
import FloatingTextFiled from "../../../sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import React, { useEffect, useRef, useState } from "react";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { fetchUser } from "../../../../helpers/helper";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";

const VerifyAccountDetail = () => {
  const api = useApi();
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user?.user);
  const [email, setEmail] = useState(null);
  const [alredayEmail, setAlredayEmail] = useState(null);
  const [editableField, setEditableField] = useState(null);
  const [showButton, setShowButton] = useState(false);
  const inputRefs = useRef({});

  const handleEditClick = (fieldId) => {
    setEditableField(fieldId);

    setTimeout(() => {
      if (inputRefs.current[fieldId]) inputRefs.current[fieldId].focus();
    }, 100);
  };

  const save = async () => {
    try {
      if (alredayEmail !== email) {
        if (!/\S+@\S+\.\S+/.test(email))
          return toastify("Please enter a valid email address", "error");

        const response = await api("post", "multiCommunity/updateUserEmail", {
          email,
          mainLeader: user?.mainLeader?._id,
        });

        if (response?.status) {
          setEditableField(null);
          setShowButton(false);
          await fetchUser(api, dispatch, storeUser);
          toastify("Your email is changed.", "success");
        }
      } else {
        setEditableField(null);
        setShowButton(false);
        toastify("you did not change email", "error");
      }
    } catch (error) {
      setEditableField(null);
      setShowButton(false);
    }
  };

  useEffect(() => {
    if (user?.role === "leader") {
      setEmail(user?.mainLeader?.email);
      setAlredayEmail(user?.mainLeader?.email);
    } else {
      setEmail(user?.email);
      setAlredayEmail(user?.email);
    }
  }, [user]);

  return (
    <>
      <div className="accountDetailBox">
        <div className="headingBox">
          <h2 className="title">Account Details</h2>{" "}
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-6 col-12">
            <div className="editable-field fixedWidth1440-298 mx-auto">
              <FloatingTextFiled
                className="accdetailinputbox"
                disabled={editableField !== "email"}
                forLabel="email"
                id="email"
                label="Email"
                onChange={(e) => {
                  setShowButton(true);
                  setEmail(e.target.value);
                }}
                placeholder="Email"
                ref={(el) => (inputRefs.current["email"] = el)}
                type="email"
                value={email}
                focusedAllowed={false}
              />
              <span
                className="edit-icon"
                onClick={() => handleEditClick("email")}
                style={{ cursor: "pointer", marginLeft: "10px" }}
              >
                <img alt="Edit Icon" src={editIcon} />
              </span>
            </div>
          </div>

          <div className="col-lg-3 col-md-12 col-12 order-lg-5 order-md-5 order-4 offset-lg-5">
            <div className="d-flex justify-content-end align-items-center">
              {showButton && (
                <BubbleSvgButton
                  onClick={save}
                  text={"Save edits"}
                  type="button"
                  variant="black"
                  containerStyling={{
                    justifyContent: "center",
                    padding: 0,
                  }}
                  mainDivStyle={{
                    width: "215px",
                    height: "55px",
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyAccountDetail;
